import { render, staticRenderFns } from "./hebeiProjectList.vue?vue&type=template&id=47b0b1ba&scoped=true"
import script from "./hebeiProjectList.vue?vue&type=script&lang=js"
export * from "./hebeiProjectList.vue?vue&type=script&lang=js"
import style0 from "./hebeiProjectList.vue?vue&type=style&index=0&id=47b0b1ba&prod&lang=less"
import style1 from "./hebeiProjectList.vue?vue&type=style&index=1&id=47b0b1ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0b1ba",
  null
  
)

export default component.exports